import React, {useState} from "react";
import PropTypes from "prop-types";
import {useSearchParams} from "react-router-dom";

import {EXPRESSION_TRUE, EXPRESSION_FALSE} from "../../../constants/filter";

const Input = function (
    {
        index,
        filter,
        columns,
        query_divider = '~'
    }
) {
    const [searchParams, setSearchParams] = useSearchParams();
    const [updated, setUpdated] = useState(false);
    if (EXPRESSION_TRUE === filter.expression || EXPRESSION_FALSE === filter.expression) {
        return null;
    }
    const column = columns.find(col => col.key === filter.column);
    if (column && column.values) {
        return (
            <select
                className='filter-select'
                value={'' + filter.value}
                onChange={event => {
                    searchParams.set('value' + query_divider + index, event.target.value);
                    setSearchParams(searchParams);
                }}
            >
                <option key='none' value=''>Please select</option>
                {column.values.map((value, key) => {
                    return (
                        <option key={key} value={value.value}>{value.label}</option>
                    );
                })}
            </select>
        );
    }
    if (column && column.hasOwnProperty('component')) {
        return column.component(value => {
            const searchParamsNew = new URLSearchParams(location.search);
            searchParamsNew.set('value' + query_divider + index, !!value ? value : '');
            setSearchParams(searchParamsNew);
        }, index);
    }

    return (
        <input
            type='text'
            className='filter-input'
            value={!updated && (!filter.value || '' === filter.value) && column && column.default ? column.default : filter.value}
            onChange={event => {
                setUpdated(true);
                searchParams.set('value' + query_divider + index, event.target.value);
                setSearchParams(searchParams);
            }}
        />
    );
}

Input.propTypes = {
    index: PropTypes.number.isRequired,
    filter: PropTypes.shape({
        column: PropTypes.string.isRequired,
        expression: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]).isRequired,
    }).isRequired,
    columns: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        expressions: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
        multiple: PropTypes.bool,
        default: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        component: PropTypes.func
    })).isRequired,
    query_divider: PropTypes.string
};

export default Input;
